import React from "react";
import { Button, Form, Table, Dropdown, DropdownButton } from "react-bootstrap";
import { Card, CardBody } from "../../../_metronic/_partials/controls/Card";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import CustomDropdownWithOther from '../../components/customDropdownWithOther';

export default class ResidentInsuranceComponent extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            formValidated: false,
            isEdit: false,
            residentInsuranceList: props.residentInsuranceList || [],
            residentInfoInsurances: [],
            selectedInsurance: { id: '', name: '', policyNo: null },
            policyNo: '',
            displayErrorInCustomComponent: false,
            errorMessageForCustomComponent: '',
            formSubmitted: false,
            showForm: false,
            selectedIndex: -1
        };
    }

    componentDidMount() {
        this.getResidentInfoInsurances();
    }
    getInsuranceList = () => {
        return this.state.residentInsuranceList;
    }

    /**
     * Adds or updates Medicare (Primary, fkInsuranceId 103) in residentInsuranceList,
     * or removes it when policyNoR is empty. Keeps parent in sync via selectInsurance.
     */
    addMedicareInsurance = (policyNoR) => {
        if (policyNoR === '' || policyNoR == null) {
            const savedInsurance = JSON.parse(JSON.stringify(
                this.state.residentInsuranceList.filter(obj =>
                    !(obj.fkInsuranceLevelId === 1 && obj.fkInsuranceId === 103)
                )
            ));
            this.setState({ residentInsuranceList: savedInsurance }, () => {
                if (this.props.selectInsurance) this.props.selectInsurance(savedInsurance);
            });
            return;
        }
        let isUpdated = false;
        const savedInsurance = JSON.parse(JSON.stringify(
            this.state.residentInsuranceList.map(ins => {
                if (ins.fkInsuranceId === 103 && ins.fkInsuranceLevelId === 1) {
                    ins.policyNo = policyNoR;
                    isUpdated = true;
                }
                return ins;
            })
        ));
        if (!isUpdated) {
            savedInsurance.push({
                insuranceName: "MEDICARE",
                insuranceLevel: "Primary",
                fkInsuranceLevelId: 1,
                fkInsuranceId: 103,
                policyNo: policyNoR,
                id: 0,
                isAddEdit: true,
                fkResidentId: this.props.residentID
            });
        }
        this.setState({ residentInsuranceList: savedInsurance }, () => {
            if (this.props.selectInsurance) this.props.selectInsurance(savedInsurance);
        });
    }

    upsertInsurance = async (insuranceName) => {
            try {
                const result = await Api.getRequestQry(
                    Api.URI_ValidateInsurance, `?insuranceName=${insuranceName}`
                );
                return result?.data?.result;
            } catch (error) {
                console.error("Error validating insurance:", error);
                // You might want to show an error message to the user here
                return null;
            }
    };

    getResidentInfoInsurances = async() => {
        try {
            const result = await Api.getRequest(Api.URI_GetAllResidentInfoInsurances, true);
            this.setState({ residentInfoInsurances: result?.data?.result });
        } catch (error) {
            console.error("Error getting resident info insurances:", error);
        }
    };

    handleEdit = (insurance,index) => {
        this.setState({
            isEdit: true,
            selectedInsurance: { id: insurance.fkInsuranceId, name: insurance.insuranceName, policyNo: insurance.policyNo },
            policyNo: insurance.policyNo,
            formSubmitted: false,
            showForm: true,
            selectedIndex: index
        });
    };

    insuranceOnChange = (value) => {
        if(value.name) {
            this.setState({ selectedInsurance: value });
        }
    }

    policyOnChange = (value) => {
        this.setState({ policyNo: value, formSubmitted: false });
    }

    handleDelete = (index) => {
        const updatedList = this.state.residentInsuranceList.filter((item, i) => i !== index);
        this.setState({
          residentInsuranceList: updatedList,
          tableData: updatedList,
        });
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            this.setState({ formValidated: true });
        } else {
            await this.upsertResidentInsurance();
        }
    };
    
    upsertResidentInsurance = async() => {
        var { selectedInsurance, policyNo, residentInsuranceList } = this.state;
        const validatedInsurance = await this.upsertInsurance(selectedInsurance.name);
        if (!validatedInsurance) {
            Common.showSuccessAlert("Failed to validate insurance", "warning", "Failed!", 3000);
            return;
        }else{
            selectedInsurance = { id: validatedInsurance.id, name: validatedInsurance.insuranceName , policyNo: policyNo};
        }
        const newInsurance = {
            id: 0,
            fkInsuranceId: selectedInsurance.id,
            insuranceName: selectedInsurance.name,
            policyNo: policyNo,
            fkResidentId: this.props.residentID
        };
    
        let updatedList;
        if (this.state.isEdit) {
            updatedList = residentInsuranceList.map((item,index) => 
                index === this.state.selectedIndex ? newInsurance : item
            );
            this.setState({ selectedIndex: -1 }); // Reset selectedIndex = -1;
        } else {
            updatedList = [...residentInsuranceList, newInsurance];
        }
        this.setState({
            residentInsuranceList: updatedList,
            showForm: false,
        }, () => {
            console.log("Updated insurance list:", this.state.residentInsuranceList);
        });
    
        Common.showSuccessAlertAutoClose("Insurance Created Successfully", "success", "Success!", 3000);
        this.resetForm();
    };

    resetForm = () => {
        this.setState({
            isEdit: false,
            selectedInsurance: { id: '', name: '' },
            policyNo: '',
            formValidated: false,
            displayErrorInCustomComponent: false,
            errorMessageForCustomComponent: '',
            formSubmitted: false,
            showForm: false,
            selectedIndex: -1
        });
    };

    render() {
        const {
            showForm, selectedInsurance, residentInfoInsurances, policyNo,
            formValidated, formSubmitted, isEdit, residentInsuranceList
        } = this.state;
        return (
            <Card className="bg-light">
                <CardBody>
                    {!showForm && (
                        <Button 
                            variant="primary" 
                            className="mb-3" 
                            onClick={() => this.setState({ showForm: true, isEdit: false, formSubmitted: false })}
                        >
                            Add New Insurance
                        </Button>
                    )}
                    
                    {showForm && (
                        <Form onSubmit={this.handleSubmit} validated={formValidated}>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <Form.Group>
                                        <Form.Label>Insurance</Form.Label>
                                        <CustomDropdownWithOther
                                            options={residentInfoInsurances.map(insurance => ({
                                                id: insurance.id,
                                                name: insurance.name
                                            }))}
                                            onChange={(value) => this.setState({ selectedInsurance: value })}
                                            onBlur={() => this.insuranceOnChange(this.state.selectedInsurance)}
                                            placeholder="Select Insurance"
                                            name="insurance"
                                            required={true}
                                            value={selectedInsurance}
                                            otherTextBoxPlaceholder="insurance"
                                            showError={formSubmitted && !selectedInsurance.id}
                                            errorMessage="Please select an insurance"
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <Form.Group>
                                        <Form.Label>Policy No</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={policyNo}
                                            onChange={(e) => this.policyOnChange(e.target.value)}
                                            required
                                            isInvalid={formSubmitted && !policyNo}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter a policy number.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                            </div>
                            <div className="d-flex justify-content-start mb-4">
                                <Button type="submit" variant="primary" className="mr-2">
                                    {this.state.isEdit ? 'Update' : 'Add Insurance'}
                                </Button>
                                <Button variant="light" onClick={this.resetForm}>
                                    Cancel
                                </Button>
                            </div>
                        </Form>
                    )}
                    <div style={{ overflowX: 'auto' }}>
                        <Table hover responsive className="mb-4" key={residentInsuranceList.length}>
                            <thead>
                                <tr>
                                    <th>Insurance Name</th>
                                    <th>Policy No</th>
                                    <th style={{ width: '100px' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {residentInsuranceList.length > 0 ? (
                                    residentInsuranceList.map((insurance, index) => (
                                        <tr key={index}>
                                            <td>{insurance.insuranceName}</td>
                                            <td>{insurance.policyNo}</td>
                                            <td>
                                            <DropdownButton
                                                drop="start"
                                                size="sm"
                                                variant="primary"
                                                title="Actions"
                                                id={`dropdown-button-drop-${index}`}
                                                key={`dropdown-${index}`}
                                            >
                                                <Dropdown.Item onClick={() => this.handleEdit(insurance,index)}>Edit</Dropdown.Item>
                                                <Dropdown.Item onClick={() => this.handleDelete(index)}>Remove</Dropdown.Item>
                                            </DropdownButton>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center">No insurance data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </CardBody>
            </Card>
        );
    }
}